export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["numer"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nazwa"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Anulować"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ratować"])}
}